import React from 'react'
import styled from 'styled-components'

const BottomSticky = styled.div`
  position: fixed;
  font-size: 14px;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #333;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60px;
  z-index: 999;
  padding: 10px 30px;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
`;

const BottomWarning = () => {
  return(
    <BottomSticky>
      ⚠️ This site shows what By The Bay looked like in November 2018. By The Bay is no longer running, and features on this site may not work as originally intended.
    </BottomSticky>
  )
}

export default BottomWarning;



// WEBPACK FOOTER //
// ./src/layout/BottomWarning.js